<template>
  <div class="quero-bolsa-info" >
    <b-container>
      <div class="quero-bolsa-info__wrapper" >
        <div class="quero-bolsa-info__illustration">
          <VLazyImage
            :src="queroBolsaInfoIllustration"
            class="quero-bolsa-info__illustration-image"
            width="304"
            height="242"
          />
        </div>
        <div class="quero-bolsa-info__content">
          <z-title
            class="quero-bolsa-info__title"
            size="small"
          >
            Com o Quero Bolsa, entrar na faculdade é muito mais fácil!
          </z-title>
          <z-text
            class="quero-bolsa-info__text"
            size="medium"
          >
            O Quero Bolsa é a maior plataforma de bolsas de estudo para ensino superior da América Latina.
            Nós ajudamos você a entrar na faculdade, oferecendo bolsas de estudo, produtos e serviços.
          </z-text>

          <z-text
            class="quero-bolsa-info__text"
            size="medium"
          >
            Veja como é simples começar a estudar:
          </z-text>

          <div>
            <div class="quero-bolsa-info__step">
              <div class="quero-bolsa-info__step-description">
                <z-title
                  class="quero-bolsa-info__title"
                  size="micro"
                >
                  Encontre seu curso
                </z-title>
                <z-text
                  class="quero-bolsa-info__text"
                  size="medium"
                >
                  Busque informações sobre cursos, bolsas de estudo, faculdades e preços.
                  Você pode informar a sua localização e a gente mostra quais vagas estão mais próximas a você.
                </z-text>
              </div>
            </div>

            <div class="quero-bolsa-info__step">
              <div class="quero-bolsa-info__step-description">
                <z-title
                  class="quero-bolsa-info__title"
                  size="micro"
                >
                  Garanta sua bolsa de estudo
                </z-title>
                <z-text
                  class="quero-bolsa-info__text"
                  size="medium"
                >
                  Pague a pré-matrícula e estude com o menor preço até o fim do curso.
                  Você pode pagar no boleto ou parcelar em até 12 vezes no cartão de crédito.
                </z-text>
              </div>
            </div>

            <div class="quero-bolsa-info__step">
              <div class="quero-bolsa-info__step-description">
                <z-title
                  class="quero-bolsa-info__title"
                  size="micro"
                >
                  Economize até se formar!
                </z-title>

                <z-text
                  class="quero-bolsa-info__text"
                  size="medium"
                >
                  É só passar no processo seletivo da faculdade e concluir a matrícula.
                </z-text>
              </div>
            </div>
          </div>

          <z-button
            class="quero-bolsa-info__button"
            variant="primary"
            type="submit"
            @click="redirectToQueroBolsa"
          >
            Encontrar minha bolsa
          </z-button>
        </div>
      </div>
    </b-container>
  </div>
</template>

<script>
import { ZButton, ZText, ZTitle } from '@quero/zilla-vue';
import VLazyImage from "v-lazy-image";

import queroBolsaInfoIllustration from '~/assets/images/illustrations/localizacao.svg';

export default {
  name: 'QueroBolsaInfo',
  components: {
    ZButton,
    ZText,
    ZTitle,
    VLazyImage,
  },
  data() {
    return {
      queroBolsaInfoIllustration,
    };
  },
  methods: {
    redirectToQueroBolsa() {
      window.location.assign('https://querobolsa.com.br?utm_source=gabarito-enem');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@quero/zilla-core/src/utils/functions.scss";
@import "@quero/zilla-core/src/utils/variables.scss";

.quero-bolsa-info {
  background-color: var(--color-neutral-white);

  @media (min-width: $screen-sm-min) {
    padding-bottom: 64px;
  }
}

.quero-bolsa-info__wrapper {
  display: flex;
  flex-direction: column-reverse;
  padding-top: $space-j;

  @media (min-width: $screen-sm-min) {
    flex-direction: row;
  }
}

.quero-bolsa-info__illustration {
  align-items: center;
  display: flex;
  justify-content: center;
  margin-top: $space-j;

  @media (min-width: $screen-sm-min) {
    margin-top: 0;
    padding-left: $space-xl;
    padding-right: $space-xl;
  }
}

.quero-bolsa-info__illustration-image {
  width: 304px;
}

.quero-bolsa-info__title-step {
  display: inline;
}

.quero-bolsa-info__step {
    counter-increment: step 1;
    display: flex;
    font-family: $font-family;
    position: relative;

  &:before {
    align-items: center;
    background-color: var(--color-brand-primary-pure);
    border-radius: 50%;
    color: var(--color-neutral-white);
    content: counter(step);
    display: flex;
    font-size: rem(13);
    font-weight: $font-weight-bold;
    justify-content: center;
    position: absolute;
    width: $size-st;
    height: $size-st;
    z-index: 1;
  }


  &:not(:last-child):after {
    border-left: $space-xs solid var(--color-brand-primary-pure);
    content: "";
    height: 100%;
    left: 10px;
    position: absolute;
    top: 8px;
  }
}

.quero-bolsa-info__step-description {
  margin-left: $size-xl;
}

.quero-bolsa-info__title {
  padding-bottom: $space-s;
}

.quero-bolsa-info__text {
  margin-bottom: $space-st;
}

.quero-bolsa-info__button {
  margin-top: $space-m;
  width: 100%;

  @media (min-width: $screen-sm-min) {
    margin-left: $size-xl;
    width: auto;
  }
}
</style>
